<template>
  <div
    class="table__row"
    :style="{width: props.tableWidth + 'px'}"
  >
    <RowCell
      v-for="(cell, cellIndex) in visibleColumns"
      :key="`${props.rowIndex}-${cellIndex}`"
      :cell-count="visibleColumns.length - 1"
      :header-cell="cell"
      :row="props.row"
      :row-index="props.rowIndex"
      :cell-index="cellIndex"
      :readonly="cell.readonly || false"
      :class="{ 'table__row--checked': props.row.checked, 'table__row--error': row.status === 'error' }"
      @edit-row="emit('edit-row')"
      @update-row="args => emit('update-row', args)"
    />
  </div>
</template>

<script setup>
import {computed, defineProps} from "vue";
import RowCell from "@/components/table/RowCell.vue";

const props = defineProps({
  row: {
    type: Object,
    required: true
  },
  rowIndex: {
    type: Number,
    required: true
  },
  tableWidth: {
    type: Number,
    required: true
  },
  columnList: {
    type: Array,
    required: true
  },
  tableData: {
    type: Array,
    required: true
  }
});

const emit = defineEmits(["edit-row", "update-row"]);

const visibleColumns = computed(() =>
    props.columnList.filter(col => {
      return col.hide === false;
    })
);
</script>

<style lang="scss" >
.table {
  &__row {
    //overflow: hidden;
    position: relative;
    display: flex;
    white-space: nowrap;
    height: 10%;

    &:hover .edit-row-button {
      opacity: 1;
      pointer-events: auto;
    }

    &:hover .table-cell {
      background: var(--outline-grey2);
      scrollbar-color: unset;
    }

    &--error {
      color: #FA665C;
    }

    &--checked {
      color: #1F9AFF;
    }
    &._isDeleted {
      & .name {
        color: red;
        & .icon-deleted {
          display: block;
        }
      }
    }
    &:first-child {
      & .table-cell {
        &.active {
          // border-top: 1px solid var(--button-focused);
          &:not(.readonly) {
            background: #eef1ff;
          }
        }
      }
    }
    & .table-cell {
      &.active-only-one {
        &:not(.readonly) {
          border-bottom: 1px solid var(--button-focused);
          border-top: 1px solid var(--button-focused);
          border-right: 1px solid var(--button-focused);
          border-left: 1px solid var(--button-focused);
        }
      }
      &.active {
        &:not(.readonly) {
          background: #eef1ff;
          border-color: transparent;
        }
        // border-bottom: 1px solid var(--button-focused);
        // border-top: 1px solid var(--button-focused);
        // border-right: 1px solid var(--button-focused);
        // border-left: 1px solid var(--button-focused);

      }
      &.hide {
        display: none;
      }
      &.readonly {
        cursor: default;
        & input {
          cursor: default;
        }
      }
    }
  }
}
</style>